import { TypedSopNode } from "./_Base";
import { OceanPlaneSopOperation } from "../../operations/sop/OceanPlane";
import { NodeParamsConfig, ParamConfig } from "../utils/params/ParamsConfig";
const DEFAULT = OceanPlaneSopOperation.DEFAULT_PARAMS;
class OceanPlaneSopParamsConfig extends NodeParamsConfig {
  constructor() {
    super(...arguments);
    this.main = ParamConfig.FOLDER();
    this.direction = ParamConfig.VECTOR3(DEFAULT.direction.toArray());
    this.sunDirection = ParamConfig.VECTOR3(DEFAULT.sunDirection.toArray());
    this.sunColor = ParamConfig.COLOR(DEFAULT.sunColor.toArray());
    this.waterColor = ParamConfig.COLOR(DEFAULT.waterColor.toArray());
    this.reflectionColor = ParamConfig.COLOR(DEFAULT.reflectionColor.toArray());
    this.reflectionFresnel = ParamConfig.FLOAT(DEFAULT.reflectionFresnel);
    this.wavesHeight = ParamConfig.FLOAT(DEFAULT.wavesHeight, {
      range: [0, 10],
      rangeLocked: [false, false]
    });
    this.distortionScale = ParamConfig.FLOAT(DEFAULT.distortionScale, {
      range: [0, 1],
      rangeLocked: [true, false]
    });
    this.timeScale = ParamConfig.FLOAT(DEFAULT.timeScale, {
      range: [0, 2],
      rangeLocked: [true, false]
    });
    this.size = ParamConfig.FLOAT(DEFAULT.size, {
      range: [0, 100],
      rangeLocked: [true, false]
    });
    this.advanced = ParamConfig.FOLDER();
    this.renderReflection = ParamConfig.BOOLEAN(DEFAULT.renderReflection);
    this.normalBias = ParamConfig.FLOAT(DEFAULT.normalBias, {
      range: [0, 0.1],
      rangeLocked: [false, false]
    });
    this.multisamples = ParamConfig.INTEGER(DEFAULT.multisamples, {
      range: [0, 4],
      rangeLocked: [true, false]
    });
    this.useFog = ParamConfig.BOOLEAN(DEFAULT.useFog);
  }
}
const ParamsConfig = new OceanPlaneSopParamsConfig();
export class OceanPlaneSopNode extends TypedSopNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
  }
  static type() {
    return "oceanPlane";
  }
  initializeNode() {
    this.io.inputs.setCount(1);
  }
  async cook(input_contents) {
    this._operation = this._operation || new OceanPlaneSopOperation(this._scene, this.states, this);
    const core_group = await this._operation.cook(input_contents, this.pv);
    this.setCoreGroup(core_group);
  }
}
